(function ($) {
    $.fn.signPortfolioItem = function () {
        return this.each(function () {
            var $this = $(this);

            var dialogWording = 'Are you sure you wish to sign this form?';

            $this.confirmClick({
                cancelCallback: function () {
                    $(this).protectClickTwiceReset();
                },
                confirmMessage: dialogWording,
                okLabel: 'Sign this form'
            });
        });
    };
}(jQuery));